
import { createSlice } from "@reduxjs/toolkit";

let initialServiceRequest = {}
const viewServiceRequestSlice = createSlice({
    name: 'currentServiceRequest',
    initialState: initialServiceRequest,
    reducers: {
        setServiceRequest: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetServiceRequest: () => {
            return initialServiceRequest
        }
    },
});

export const { setServiceRequest, resetServiceRequest } = viewServiceRequestSlice.actions;
export default viewServiceRequestSlice.reducer;